import { Controller } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { Lens } from "@hookform/lenses"
import { CheckedState } from "@radix-ui/react-checkbox"
import { SingleCheckbox } from "@/components/ui/checkbox"
import { PointOfCareFormType } from "@/modules/patients/detail/progress-note/point-of-care/schema"

type DoctorVisitAvoidedContentProps = {
  isDoctorVisitAvoidedLens: Lens<PointOfCareFormType["isDoctorVisitAvoided"]>
}

export const DoctorVisitAvoidedContent = ({ isDoctorVisitAvoidedLens }: DoctorVisitAvoidedContentProps) => {
  const { t } = useTranslation()
  const { control, name } = isDoctorVisitAvoidedLens.interop()

  return (
    <label className="flex flex-row justify-between gap-4">
      <span className="pt-4">{t("episodeOfCare.progressNote.pointOfCare.treatmentAvoided")}</span>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <SingleCheckbox
            className="pt-1 transition-all duration-300 has-focus-visible:mt-2"
            checked={field.value ?? false}
            onCheckedChange={(checkedState: CheckedState): void => field.onChange(checkedState === true)}
          />
        )}
      />
    </label>
  )
}
